<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisTabs from 'dashboard/components-next/LaisTabs.vue';

const props = defineProps({
  modelValue: { type: String, required: true },
  counts: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['update:modelValue']);
const { t } = useI18n();
const tabs = computed(() => [
  {
    id: 'andamento',
    label: t('NUCLEO_WORK_ORDERS.TABS.IN_PROGRESS'),
    badge: props.counts.andamento,
  },
  {
    id: 'finalizados',
    label: t('NUCLEO_WORK_ORDERS.TABS.COMPLETED'),
    badge: props.counts.finalizados,
  },
]);
</script>

<template>
  <LaisTabs
    :model-value="modelValue"
    :tabs="tabs"
    :aria-label="t('NUCLEO_WORK_ORDERS.ARIA.TABS')"
    fill
    @update:model-value="emit('update:modelValue', $event)"
  />
</template>
